<div
	class="modal-component"
	[class.right]="properties.position === 'right' && !properties.removeStyle"
	[class.center]="properties.position === 'center' && !properties.removeStyle"
	[class.right-small]="properties.width === 'right-small' && !properties.removeStyle"
	[class.no-background]="properties.removeStyle === true"
	[class.remove-style]="properties.removeStyle === true"
>
	<div cdkScrollable id="modal-scroll" class="modal-content">
		<ng-container *ngTemplateOutlet="template"></ng-container>
	</div>
</div>
